/** @jsx jsx */
import { jsx, css } from '@emotion/core' // eslint-disable-line

export const ViewerStyles = {
  'drawer-container': css`
    width: 100%;
    height: 100%;

    .ant-spin-nested-loading, .ant-spin-container {
      position: static;
    }
  `,
  'data-drawer': css`
    .ant-btn+.ant-btn {
      margin-top: 8px;
    }
  `,
  'drawer-body': css`
    margin-bottom: 32px;
  `,
  'drawer-footer': css`
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100%;
    border-top: 1px solid #e9e9e9;
    padding: 10px 16px;
    background: #fff;
    text-align: right;

    .ant-btn+.ant-btn {
      margin-left: 8px;
    }
  `,
  'title': css`
    font-size: 16;
    color: rgba(0,0,0,0.85);
    line-height: 24px;
    display: block;
    margin-bottom: 16;
  `,
  'description': css`
    font-size: 14;
    line-height: 22px;
    margin-bottom: 7px;
    color: rgba(0,0,0,0.65);

    .viewer-title {
      margin-right: 8;
      display: inline-block;
      color: rgba(0,0,0,0.85);
    }
  `,
}

export const EditorStyles = {
  'edit-pane': css`
    .ant-form-item {
      margin-bottom: 12px;
    }
  `,
  'edit-form': css`
    .ant-form-item {
      margin-bottom: 8px;
    }

    .ant-btn+.ant-btn {
      margin-left: 8px;
    }
  `,
  'edit-hint-line': css`
    .inline-hint {
      display: flex;
      flex-direction: column;

      height: 24px;
      font-size: 12px;
    }
  `,
  'edit-label': css`
    .label-title {
      font-weight: bold;
    }
  `,
  'edit-label-title': css`
    font-weight: bold;
  `,
  'edit-label-hint': css`
    margin-left: 5px;
    color: #888;
    font-size: 12px;
  `,
}